import { observer } from "mobx-react";
import { Component, type ReactNode } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import LogoutIcon from "nvent-web/assets/svg/side-menu/logout.svg";
import { withAppAuth0 } from "nvent-web/services/auth0/AppAuth0Context";
import { type AppAuth0 } from "nvent-web/services/auth0/useCreateAppAuth0";

import style from "./SidebarMenu.module.scss";

interface SidebarMenuInnerProps {
  baseUrl: string;
  auth0: AppAuth0;
  children: ReactNode;
}

class SidebarMenuInner extends Component<SidebarMenuInnerProps> {
  render() {
    return (
      <nav className={style.menu}>
        {this.props.children}
        {this.renderLogOutItem()}
      </nav>
    );
  }

  private renderLogOutItem() {
    return (
      <button type="button" className={style.logoutItem} onClick={this.logOut}>
        <div className={style.simpleItem}>
          <div className={style.itemIcon}>
            <img src={LogoutIcon} />
          </div>
          <div className={style.itemText}>
            <FormattedMessage id="side.menu.logOut" />
          </div>
        </div>
      </button>
    );
  }

  private logOut = () => {
    sessionStorage.clear();
    this.props.auth0.logout();
  };
}

export const SidebarMenu = compose<{ children: ReactNode }>(
  injectIntl,
  withAppAuth0,
  observer
)(SidebarMenuInner);
export default SidebarMenu;
